module.exports = __webpack_public_path__ + "img/setting.4be130b4.png";